import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getSummaryRpc } from '../__generated__/chirp/com/hubspot/partner/client/ai/rpc/PartnerClientAiSummaryRpc';
import { REQUEST_TIMEOUT } from './constants/Request';
// This function can be called in a card registry in order to fire a request
// before your JS has loaded and evaluated.
export const dataResolver = async ({
  graphqlClient: __graphqlClient,
  dfcClient: __dfcClient
}, {
  cardData: __cardData,
  additionalLocationData: {
    objectId: objectId,
    objectTypeId: objectTypeId
  }
}) => {
  try {
    if (!objectId || !objectTypeId) {
      console.error('Missing objectId or objectTypeId');
      return {
        error: 'Missing objectId or objectTypeId'
      };
    }
    const rpcClient = createRpcClientV2({
      hubHttpClient: http
    });
    const response = await rpcClient.call(getSummaryRpc, {
      request: {
        partnerClientId: objectId
      },
      timeout: REQUEST_TIMEOUT
    });
    if (response !== null && response !== void 0 && response.result) {
      return {
        result: response.result
      };
    } else {
      return {
        error: 'No summary result received'
      };
    }
  } catch (error) {
    console.error('Error fetching summary:', error);
    return {
      error: 'Failed to fetch summary'
    };
  }
};